<template>
  <!-- 重複支付彈窗 -->
  <el-dialog
    :title="$t('message.tips')"
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="350px"
    :before-close="handleClose"
    top="30vh"
  >
    <div style="font-size: 16px; white-space: pre-line">
      {{ $t("message.ErrorMessage.REPEAT_PAYMENT_ERROR") }} {{ rocallTime }}
      {{ $t("message.ErrorMessage.REPEAT_PAYMENT_ERROR1") }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
var myTime;
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    timeParams: Object,
  },
  data() {
    return {
      rocallTime: "00:00",
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.ComputetTime(this.timeParams);
      }
    },
  },
  methods: {
    handleClose() {
      clearTimeout(myTime);
      this.$emit("close");
    },
    //支付倒计时
    ComputetTime(data) {
      let st = data.currentTime.replace(/\-/g, "/"), //当前服务器时间
        ct = data.formatCreateTime.replace(/\-/g, "/"); //创建订单时间
      let ts = new Date(st).getTime(),
        tc = new Date(ct).getTime();
      let cm = 5 * 60 * 1000 - (ts - tc);
      this.runBack(cm);
    },
    runBack(cm) {
      if (cm > 0) {
        cm > 60000
          ? (this.rocallTime =
              (new Date(cm).getMinutes() < 10
                ? "0" + new Date(cm).getMinutes()
                : new Date(cm).getMinutes()) +
              ":" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()))
          : (this.rocallTime =
              "00:" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()));
        let _msThis = this;
        myTime = setTimeout(function () {
          cm -= 1000;
          _msThis.runBack(cm);
        }, 1000);
      } else {
        this.$emit("close");
      }
    },
  },
};
</script>

<style>
</style>